class VideoPlayer {
    constructor(_option){
        if(!_option && typeof(_option) !== 'object') {
            throw new TypeError("Player module need object type option");
        }

        if(_option && !document.querySelector(_option.selector)) {
            throw new TypeError(`no ${_option.selector} DOM Element`);
        }

        this.context = $(_option.selector);

        this.player = null;

        this.config = $.extend({
            fps: 60,
            videoId: '',
            playerId: '',
            mute: false,
            autoPlay: false,
            loop: false,
            controls: false,
            coverClick: false,
            poster: false
        }, _option);

        this.config.playerId = `${_option.selector.replace(/^#/, '')}__screen`;

        this.state = {
            isPlay: false,
            isControlShow: true,
            animationFrame: 0,
            timer: 0,
            isReady: false,
            firstPlay: false
        };

        this.template = {
            player: `<video id="${this.config.playerId}" ${this.config.autoPlay ? 'autoplay' : '' } ${this.config.mute ? 'muted' : '' }  playsinline  >
				        <source src="${this.config.videoId}" type="video/${this.config.videoId.substring(_option.videoId.lastIndexOf('.', _option.videoId.length)).toLowerCase().split('.')[1]}">
					</video>
					`,
            controls: `<div class="player__controls">
							<div class="player__progress">
								<div class="player__progress-bar"></div>
					   		</div>
							<button type="button" class="player__play player__play_show">재생</button>
							<button type="button" class="player__pause">정지</button>
					   </div>`,
            cover: `<div class="player__cover"></div>`,
            poster: `<div class="player__poster" style="background:url('${this.config.poster}') no-repeat 50% 50%"></div>`
        };

        this.DOM = {
            controls: null,
            progress: null,
            progressBar: null,
            play: null,
            pause: null,
            poster: false
        };

        this.dimension = {
            progress: 0,
            progressLeft: 0,
        };

        this._handleStateChange = this._handleStateChange.bind(this);
        this._handleReady = this._handleReady.bind(this);
        this._animationFrame = this._animationFrame.bind(this);
    }

    init(){
        this._setPlayer();
    }

    _setPlayer(){
        this._renderPlayer();
        this.video = $('#' + this.config.playerId)[0];
        this.video.load();

        this._detectDom();
        this._detectDimension();

        $(this.video).on('canplay', this._handleReady);
    }

    _renderPlayer(){
        this.context.append(this.template.player);
        this.context.append(this.template.cover);
        this.config.poster && this.context.append(this.template.poster);
        this.config.controls && this.context.append(this.template.controls);
    }

    _detectDom(){
        this.DOM.poster = this.config.poster && this.context.find('.player__poster');

        if(this.config.controls) {
            this.DOM.controls = this.context.find('.player__controls');
            this.DOM.progress = this.context.find('.player__progress');
            this.DOM.progressBar = this.context.find('.player__progress-bar');
            this.DOM.play = this.context.find('.player__play');
            this.DOM.pause = this.context.find('.player__pause');
        }
    }

    _detectDimension(){
        if(this.config.controls) {
            this.dimension.progress = this.DOM.progress.width();
            this.dimension.progressLeft = this.DOM.progress[0].getBoundingClientRect().left;
        }
    }

    _setMovieSize(){
        const contextWidth = this.context[0].offsetWidth;
        const contextHeight = this.context[0].offsetHeight;

        const videoWidth = this.video.videoWidth;
        const videoHeight = this.video.videoHeight;

        let setWidth = 0;
        let setHeight = 0;

        if((contextWidth / contextHeight) < (videoWidth / videoHeight)) {
            setWidth = contextHeight * videoWidth / videoHeight;
            setHeight = contextHeight;
        } else {
            setWidth = contextWidth;
            setHeight = contextWidth * videoHeight / videoWidth;
        }

        $(`#${this.config.playerId}`).css({
            width: setWidth,
            height: setHeight
        });
    }

    _setEvent(){
        if(this.config.controls) {
            this.context.on('click', '.player__play', () =>{
                this.play();
            });

            this.context.on('click', '.player__pause', () =>{
                this.pause();
            });

            this.context.on('click', '.player__progress', (e) =>{
                this.seek((1 - (this.dimension.progress - (e.clientX - this.dimension.progressLeft)) / this.dimension.progress) * this.video.duration);

                if(!this.state.isPlay) {
                    this._handleProgressUpdate((e.clientX - this.dimension.progressLeft) / this.dimension.progress);
                }

                this.state.firstPlay || this.play();
            });

            this.context.on('mousemove', (e) =>{
                if(!this.state.isPlay) return;

                if(e.target === this.DOM.progress[0] || e.target === this.DOM.progressBar[0] || e.target === this.DOM.play[0] || e.target === this.DOM.pause[0]) return;

                if(!this.state.isControlShow) {
                    this.state.isControlShow = true;

                    this.DOM.controls.removeClass('player__controls_hide');
                } else {
                    clearTimeout(this.state.timer);

                    this.state.timer = setTimeout(() =>{
                        if(!this.state.isPlay) return;
                        this.state.isControlShow = false;

                        this.DOM.controls.addClass('player__controls_hide');
                    }, 1000);
                }
            });

            this.context.on('mouseover', '.player__controls', () =>{
                if(!this.state.isPlay) return;

                clearTimeout(this.state.timer);

                this.DOM.controls.removeClass('player__controls_hide');
            });

            this.context.on('mouseout', '.player__controls', () =>{
                if(!this.state.isPlay) return;

                clearTimeout(this.state.timer);

                this.state.timer = setTimeout(() =>{
                    if(!this.state.isPlay) return;
                    this.state.isControlShow = false;

                    this.DOM.controls.addClass('player__controls_hide');
                }, 1000);
            });
        }

        if(this.config.coverClick) {
            this.context.on('click', '.player__cover', () =>{
                this.state.isPlay ? this.pause() : this.play();
            });
        }

        $(window).on('resize.player', () =>{
            this.config.controls && this._detectDimension();
            this._setMovieSize();
        });

        $(this.video).on('ended', () =>{
            this._handleStateChange('end');
        });

        $(this.video).on('play', () =>{
            this._handleStateChange('play');
        });

        if(this.config.autoPlay) {
            $(this.video).one('playing', () =>{
                this._handleStateChange('play');
            });
        }

        $(this.video).on('timeupdate', () =>{
            this.config.poster && this.DOM.poster.hide();
        });

        $(this.video).on('pause', () =>{
            this._handleStateChange('pause');
        });

        $(this.video).on('durationchange', (e) =>{
            this._setMovieSize();
        });
    }

    _handleReady(){
        this.state.isReady = true;
        $(this.video).off('canplay');
        $(window).trigger(`canplay.${this.config.selector.replace(/^#/, '')}`);

        this._setMovieSize();
        this._setEvent();
        $(this.video).addClass('isReady');

        this.config.mute && this.mute();

        if(this.config.autoPlay) {
            this.play();
        }
    }

    _handleStateChange(state){
        switch(state) {
            case 'play':
                this.state.firstPlay = this.state.firstPlay || true;

                if(this.state.isPlay) return;
                this.state.isPlay = true;

                if(this.config.controls) {

                    this.DOM.play.removeClass('player__play_show');
                    this.DOM.pause.addClass('player__pause_show');

                    this.state.timer = setTimeout(() =>{
                        if(!this.state.isPlay) return;
                        this.DOM.controls.addClass('player__controls_hide');
                    }, 1000);

                    this.state.isControlShow = false;
                }

                this._animationFrame(this.state.animationFrame, this._handlePlayUpdate, this.config.fps);
                break;

            case 'pause':
                this.state.isPlay = false;
                cancelAnimationFrame(this.state.animationFrame);

                if(this.config.controls) {
                    this.DOM.play.addClass('player__play_show');
                    this.DOM.pause.removeClass('player__pause_show');
                    this.DOM.controls.removeClass('player__controls_hide');
                    this.state.isControlShow = true;
                }
                break;

            case 'end':
                this.state.isPlay = false;
                cancelAnimationFrame(this.state.animationFrame);

                if(this.config.controls) {
                    this.DOM.play.addClass('player__play_show');
                    this.DOM.pause.removeClass('player__pause_show');
                    this.DOM.controls.removeClass('player__controls_hide');
                    this.state.isControlShow = true;
                }

                this.video.pause();

                $(window).trigger(`end.${this.config.selector.replace(/^#/, '')}`);

                this.config.loop ? this.play() : this.config.poster && this.DOM.poster.show();
                break;
        }
    }

    _handlePlayUpdate(){
        this.config.controls && this._handleProgressUpdate(this.video.currentTime / this.video.duration);
    }

    _handleProgressUpdate(bar){
        this.DOM.progressBar.css({
            'transform': `scale3d(${bar > 1 ? 1 : bar}, 1,1 )`
        });
    }

    _animationFrame(reqId, doFunc){
        const loop = () =>{
            doFunc.call(this);
            this.state.isPlay && (reqId = requestAnimationFrame(loop));
        };
        loop();
    }

    play(){
        this.state.isReady && !this.state.isPlay && this.video.play();
    }

    stop(){
        this.video.pause();
        this.video.currentTime = 0;
        this._handlePlayUpdate();
    }

    pause(){
        this.video.pause();
    }

    mute(){
        this.video.muted = true;
    }

    unMute(){
        this.video.muted = false;
    }

    seek(t){
        this.video.currentTime = t;
    }
}

export default VideoPlayer;